<template>
  <v-list-item-action v-if="!loading && (value === null || value === undefined )">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on"
                size="20"
                :color="noempty ? 'orange' : 'disabled'"
                v-text="noempty ? 'mdi-alert' : 'mdi-exclamation' " />
      </template>
      {{noempty ? $t('servicesystem.common_objects.fallbackterms.illegal_empty_field') : $t('servicesystem.common_objects.fallbackterms.empty_field')}}
    </v-tooltip>
  </v-list-item-action>
</template>



<script>
export default {
  name: "EmptyValueWarning",
  props: ["value", "noempty", "loading"],

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>